import { render } from "./IconTextItalic.vue?vue&type=template&id=e7b27abe&ts=true"
import script from "./IconTextItalic.vue?vue&type=script&lang=ts"
export * from "./IconTextItalic.vue?vue&type=script&lang=ts"

import exportComponent from "/app/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__